import React from 'react';

import { useDeleteFace, useGetFace, useGetFacesCount } from '@vlabs/api/luna-api/client';
import type { FaceId } from '@vlabs/api/luna-api/model';
import { DeleteIcon } from '@vlabs/icons';
import { DropdownListItem } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import st from './DeleteFaceDropdownItem.module.sass';
import { confirmLastFaceDeletion } from '../../entities/cards';

interface DeleteFaceDropdownItemProps {
  faceId: FaceId;
  onDeleteFace: VoidFunction;
}

export function DeleteFaceDropdownItem({
  faceId,
  onDeleteFace,
}: DeleteFaceDropdownItemProps): React.JSX.Element {
  const { t } = useTranslation();
  const getFace = useGetFace(faceId);
  const deleteFace = useDeleteFace();
  // @ts-expect-error enabled
  const countFaces = useGetFacesCount({ external_ids: [getFace.data?.external_id] }, {
    query: {
      enabled: !!getFace.data?.external_id,
    },
  });
  const $onDeleteFace = async () => {
    if (getFace.data?.external_id && countFaces.data?.faces_count === 1) {
      await confirmLastFaceDeletion({ onConfirm: onDeleteFace, async: true });
    }
    await deleteFace.mutateAsync({ faceId }, {
      onSuccess: () => {
        toast.success(t('features:deleteFace.toast.success'));
      },
    });
    onDeleteFace?.();
  };

  return (
    <DropdownListItem
      className={st.Root}
      label={t('features:deleteFace.btn.delete')}
      leftIcon={<DeleteIcon />}
      onClick={$onDeleteFace}
    />
  );
}
